<template>
  <!--
    TODO: Investigate if its possible to make the navigation collapsible on mobile devices,
      without using the rail functionality as it seems a little hacky.
  -->
  <v-navigation-drawer
    v-model="drawer"
    :rail="$vuetify.display.smAndDown"
    rail-width="0"
    :location="$vuetify.display.smAndDown ? 'bottom' : 'right'"
    :temporary="$vuetify.display.smAndDown"
    :permanent="!$vuetify.display.smAndDown"
    mobile-breakpoint="sm"
    class="pod-sidemenu"
    width="480"
    ref="drawerElement"
  >
    <v-btn-toggle
      v-model="activeToolbar"
      mandatory
      max-width="100%"
      rounded="lg"
      class="d-flex"
      color="primary"
      data-cy="podSidemenuButtons-list"
    >
      <v-tooltip location="bottom" :aria-label="$t('routes.pod.menuInfo.mediaInformation')">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            variant="tonal"
            value="info"
            :rounded="false"
            icon
            class="flex-grow-1"
            style="border-radius: unset;"
            :aria-label="$t('routes.pod.menuInfo.mediaInformation')"
            data-cy="podSidemenuButtons-info"
          >
            <v-icon :color="activeToolbar === 'info' ? 'primary' : 'default'">mdi-information</v-icon>
          </v-btn>
        </template>

        <span>{{ $t('routes.pod.menuInfo.mediaInformation') }}</span>
      </v-tooltip>

      <v-tooltip v-if="$canListPodService()" location="bottom" :aria-label="$t('routes.pod.menuComment.comments')">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            value="comments"
            variant="tonal"
            :rounded="false"
            icon
            :disabled="!isVideoPod && !isAudioPod && !isImagePod"
            class="flex-grow-1"
            style="border-radius: unset;"
            :aria-label="$t('routes.pod.menuComment.comments')"
            data-cy="podSidemenuButtons-comment"
          >
            <v-icon :color="activeToolbar === 'comments' ? 'primary' : 'default'">mdi-comment</v-icon>
          </v-btn>
        </template>

        <span>{{ $t('routes.pod.menuComment.comments') }}</span>
      </v-tooltip>

      <v-tooltip v-if="$canListPodService() || $canLabelPods()" location="bottom" :aria-label="$t('routes.pod.labels')">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            value="labels"
            variant="tonal"
            :rounded="false"
            icon
            class="flex-grow-1"
            style="border-radius: unset;"
            :aria-label="$t('routes.pod.labels')"
            data-cy="podSidemenuButtons-label"
          >
            <v-icon :color="activeToolbar === 'labels' ? 'primary' : 'default'">mdi-label</v-icon>
          </v-btn>
        </template>

        <span>{{ $t('routes.pod.labels') }}</span>
      </v-tooltip>

      <v-tooltip v-if="$canListPodService()" location="bottom" :aria-label="$t('routes.pod.assetSubtitle')">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            value="subtitles"
            variant="tonal"
            :rounded="false"
            icon
            class="flex-grow-1"
            style="border-radius: unset;"
            :disabled="!isVideoPod && !isAudioPod"
            :aria-label="$t('routes.pod.assetSubtitle')"
            data-cy="podSidemenuButtons-subtitles"
          >
            <v-icon :color="activeToolbar === 'subtitles' ? 'primary' : 'default'">mdi-subtitles</v-icon>
          </v-btn>
        </template>

        <span>{{ $t('routes.pod.assetSubtitle') }}</span>
      </v-tooltip>

      <v-tooltip v-if="$canListAsset()" location="bottom" :aria-label="$t('routes.pod.mediaAssets')">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            value="assets"
            variant="tonal"
            :rounded="false"
            icon
            class="flex-grow-1"
            style="border-radius: unset;"
            data-cy="podSidemenuButtons-mediaAssets"
            :aria-label="$t('routes.pod.mediaAssets')"
          >
            <v-icon :color="activeToolbar === 'assets' ? 'primary' : 'default'">
              mdi-image-multiple-outline
            </v-icon>
          </v-btn>
        </template>

        <span>{{ $t('routes.pod.mediaAssets') }}</span>
      </v-tooltip>

      <v-tooltip v-if="$canViewPodAndNodeAnalytics()" location="bottom" :aria-label="$t('routes.pod.analyticsDialog.title')">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            value="analytics"
            variant="tonal"
            :rounded="false"
            icon
            class="flex-grow-1"
            style="border-radius: unset;"
            :aria-label="$t('routes.pod.analyticsDialog.title')"
          >
            <v-icon :color="activeToolbar === 'analytics' ? 'primary' : 'default'">mdi-poll</v-icon>
          </v-btn>
        </template>

        <span>{{ $t('routes.pod.analyticsDialog.title') }}</span>
      </v-tooltip>

      <v-tooltip v-if="$canListAsset()" location="bottom" :aria-label="$t('routes.pod.mediaLegal')">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            value="legal"
            variant="tonal"
            :rounded="false"
            icon
            class="flex-grow-1"
            style="border-radius: unset;"
            data-cy="podSidemenuButtons-mediaLegal"
            :aria-label="$t('routes.pod.mediaLegal')"
          >
            <v-icon :color="getActiveToolbar === 'legal' ? 'primary' : 'default'">mdi-file-document-multiple
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('routes.pod.mediaLegal') }}</span>
      </v-tooltip>

      <v-tooltip v-if="$canListPodService()" location="bottom" :aria-label="$t('routes.pod.authenticity.title')">
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            value="authenticity"
            variant="tonal"
            :rounded="false"
            icon
            class="flex-grow-1"
            style="border-radius: unset;"
            :disabled="!isVideoPod && (!isImagePod || !isImageFormatSupportedForAC)"
            :aria-label="$t('routes.pod.authenticity.title')"
            data-cy="podSidemenuButtons-authenticity"
          >
            <v-icon :color="activeToolbar === 'authenticity' ? 'primary' : 'default'">mdi-shield-check</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('routes.pod.authenticity.title') }}</span>
      </v-tooltip>
    </v-btn-toggle>

    <div v-if="pod" class="pod-sidemenu-content-wrapper">
      <InformationToolbar v-if="activeToolbar === 'info'" :pod="pod" :disableNotes="false" />
      <CommentsToolbar v-if="activeToolbar === 'comments' && $canListPodService() && (isVideoPod || isAudioPod || isImagePod)" />
      <LabelsToolbar v-if="activeToolbar === 'labels' && ($canListPodService() || $canLabelPods())" />
      <SubtitlesToolbar v-if="activeToolbar === 'subtitles' && $canListPodService()" />
      <AssetsToolbar v-if="activeToolbar === 'assets' && $canListAsset()" />
      <AnalyticsToolbar v-if="activeToolbar === 'analytics' && $canViewPodAndNodeAnalytics()" :pod="pod" />
      <LegalToolbar v-if="activeToolbar === 'legal' && $canListAsset()" />
      <AuthenticityToolbar v-if="activeToolbar === 'authenticity' && $canListPodService() && (isVideoPod || (isImagePod  && isImageFormatSupportedForAC))" :pod="pod" />
    </div>

  </v-navigation-drawer>
</template>

<script>
import { useMainStore } from '@/stores/MainStore.js'
import { usePodStore } from '@/stores/PodStore.js';
import MimetypeHelper from '../../../../components/MimetypeHelper.js'

import InformationToolbar from './informationToolbar/InformationToolbar.vue'
import CommentsToolbar from './commentsToolbar/CommentsToolbar.vue'
import LabelsToolbar from './labelsToolbar/LabelsToolbar.vue'
import SubtitlesToolbar from './subtitlesToolbar/SubtitlesToolbar.vue'
import AssetsToolbar from './assetsToolbar/AssetsToolbar.vue'
import AnalyticsToolbar from './analyticsToolbar/AnalyticsToolbar.vue';
import LegalToolbar from './legalToolbar/LegalToolbar.vue'
import AuthenticityToolbar from './authenticityToolbar/AuthenticityToolbar.vue'

export default {
  name: "PodSidemenu",
  components: {
    AnalyticsToolbar,
    InformationToolbar,
    CommentsToolbar,
    LabelsToolbar,
    SubtitlesToolbar,
    AssetsToolbar,
    LegalToolbar,
    AuthenticityToolbar,
  },
  data() {
    return {
      drawer: null,
      activeToolbar: 'info',
    };
  },
  watch: {
    getSidemenuToggle() {
      this.drawer = !this.drawer;
    },
    '$route.query.menu': function() {
      this.showAssetsFromURL();
    }
  },
  mounted() {
    this.showAssetsFromURL();
    this.setActiveSidemenu();
  },
  methods: {
    setActiveSidemenu() {
      const menu = this.$route.query.menu;
      if (menu) {
        const supportedToolbars = [
          'info',
          'comments',
          'labels',
          'subtitles',
          'assets',
          'legal',
          'authenticity',
        ];

        if (supportedToolbars.includes(menu)) {
          this.activeToolbar = menu;
        }
      }
    },
    showAssetsFromURL() {
      if (this.$route.query.menu === 'assets' && this.$canListAsset()) {
        this.activeToolbar = 'assets';
        this.drawer = true;

        const query = Object.assign({}, this.$route.query);
        delete query.menu;
        this.$router.replace({ query });
      }
    }
  },
  computed: {
    pod: function() {
      const podStore = usePodStore();
      return podStore.getViewPod;
    },
    isVideoPod: function() {
      return MimetypeHelper.isMimetypeVideo(this.pod);
    },
    isAudioPod: function() {
      return MimetypeHelper.isMimetypeAudio(this.pod);
    },
    isImagePod: function() {
      return MimetypeHelper.isMimetypeImage(this.pod);
    },
    getSidemenuToggle() {
      const mainStore = useMainStore();
      return mainStore.getSidemenuToggle;
    },
    getActiveToolbar() {
      const podStore = usePodStore();
      return podStore.getActiveToolbar;
    },
    isImageFormatSupportedForAC: function() {
      const mimeType = this.pod?.asset?.raw?.[0].mimetype;
      const supportedImageTypes =  ['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'image/bmp', 'image/tiff', 'image/vnd.adobe.photoshop', 'image/heic', 'image/heif'];
      return mimeType ? supportedImageTypes.includes(mimeType) : false;
    },
  }
}
</script>

<style lang="scss" scoped>
.pod-sidemenu {
  top: 70px !important;
  margin-top: 14px;
  margin-left: 4px;
  border-radius: 7px;
  max-height: calc(100% - 84px) !important;
  padding: 8px;

  &-content-wrapper {
    padding: 10px;
  }

  &.v-theme--dark {
    background-color: #232b36 !important;
  }

  &.v-theme--light {
    background-color: #FFFFFF !important;
  }
}

@media only screen and (max-width: 960px) {
  .pod-sidemenu {
    margin-left: 0;
    border-radius: 0;
  }

  .pod-sidemenu.v-navigation-drawer--active {
    height: 100vh !important;
  }
}
</style>
